module.exports = __webpack_public_path__ + "static/media/fraud-banner-mobile.ba1f264f.png";